define.alias("shared/components/shared/ui/switcher/option", "settings/components/shared/ui/switcher/option");